<div class="flex grid-cols-2 flex-col gap-4 md:grid md:justify-between">
  <h2
    class="text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
  >
    Approvals
  </h2>
</div>

<div
  *appHasPermission="'get_document_meta_data'"
  class="mt-[0.94rem] grid gap-5 lg:grid-cols-3"
>
  <div class="rounded-md bg-gray-200 p-[38px] shadow-sm">
    <!-- Your chart component goes here -->
    <div>
      <p class="text-">Total Requests</p>
    </div>
    <div>
      <h1 class="number-stat-font text-4xl">{{ totalReq || 0 }}</h1>
    </div>
  </div>
  <div class="rounded-md bg-[#fff6e8] p-[38px] shadow-sm">
    <!-- Your chart component goes here -->
    <div>
      <p>Approved Documents</p>
    </div>
    <div>
      <h1 class="number-stat-font text-4xl">
        {{ totalApproved }}
      </h1>
    </div>
  </div>
  <div class="flex items-center rounded-md bg-gray-200 p-[38px] shadow-sm">
    <!-- Your chart component goes here -->

    <div>
      <div>
        <p>Pending Requests</p>
      </div>
      <div>
        <h1 class="number-stat-font text-4xl">{{ totalPending }}</h1>
      </div>
    </div>
  </div>
</div>

<div class="tab__wrapper mb-6 mt-[0.94rem]">
  <!-- Tabs for desktop -->
  <div class="hidden w-fit rounded-lg bg-white sm:block">
    <nav class="flex w-fit space-x-4 p-[0.31rem]" aria-label="Tabs">
      <a
        *appHasPermission="'get_kyc_document_list'"
        [routerLink]="docUpdloadUrl"
        routerLinkActive="bg-mango-lightOrange text-mango"
        class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
        ><span>Document Upload</span></a
      >
      <a
        *appHasPermission="'get_update_details'"
        [routerLink]="kycUpdatesUrl"
        routerLinkActive="bg-mango-lightOrange text-mango"
        class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
        ><span>KYC Updates</span></a
      >
      <a
        *appHasPermission="'can_get_partner_kyc_document_list'"
        [routerLink]="partnerKycUrl"
        routerLinkActive="bg-mango-lightOrange text-mango"
        class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
        ><span>Partner KYC</span></a
      >
    </nav>
  </div>
</div>

<router-outlet></router-outlet>
